import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import React, {useState, useEffect, useContext} from 'react';
import {useHistory} from 'react-router-dom';
import {Context} from '../../Helpers/Auth';
import {useTranslation} from 'react-i18next';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import DrawerFilter from '../../components/Prospects/DrawerFilter';
import Tabela from '../../components/Prospects/Table';
import ProspectsForm from '../../components/Prospects/Form';
import {ToastContainer} from 'react-toastify';
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import WorkspacesOutlinedIcon from '@mui/icons-material/WorkspacesOutlined';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import {getLead} from '../../components/Leads/api';
import {getMarcas, getModelos, getNacionaisInternacionais, getTipos, getVersoes, getRepresentantes, getProspectId, getPaises, getPaisAtual} from '../requests';
import PersonPinCircleOutlinedIcon from '@mui/icons-material/PersonPinCircleOutlined';
import ListAltRoundedIcon from '@mui/icons-material/ListAltRounded';
import Mapa from '../../components/Prospects/Mapa';

function Prospects(color) {
    const {t} = useTranslation();

    // Apresenta form de prospects ou não
    const [showForm, setShowForm] = useState(false);

    // Indica se o form está em modo de edição ou não
    const [editarProspect, setEditarProspect] = useState(false);

    // Prospect que está selecionado
    const [prospectSelecionado, setProspectSelecionado] = useState(null);

    // Separador do form que está visivel
    const [openTab, setOpenTab] = React.useState(10);

    // flag para guardar prospect
    const [guardar, setGuardar] = useState(false);

    // flag com indicação de se foram efetuados alterações no prospect
    const [onChangeForm, setOnChangeForm] = useState(false);

    const history = useHistory();

    const {path, setPath} = useContext(Context);

    const [download, setDownload] = useState(false);

    const [paises, setPaises] = useState([]);

    const [novaReuniaoVisita, setNovaReuniaoVisita] = useState(false);
    const [novoNegocio, setNovoNegocio] = useState(false);

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    } 

    const handleRowClick = dados => {
        setProspectSelecionado(dados);
        setOpenTab(1);
        setShowForm(true);
        setEditarProspect(false);
    };
    const handlePopUpClick = dados => {
        const codCliente = dados.id;
        getProspectId(codCliente, lang).then(res => {
            setProspectSelecionado(res.data.cliente);
        });
        setOpenTab(1);
        setShowForm(true);
        setEditarProspect(false);
    };

    // FILTROS

    const [filtroNome, setFiltroNome] = useState('');
    const [filtroNif, setFiltroNif] = useState('');
    const [filtroCidade, setFiltroCidade] = useState('');
    const [filtroPais, setFiltroPais] = useState(null);
    const [filtroRepresentante, setFiltroRepresentante] = useState(null);

    // FILTROS PRODUTOS VENDIDOS

    const [filtroReferencia, setFiltroReferencia] = useState('');
    const [filtroDesc, setFiltroDesc] = useState('');
    const [filtroQuantidade, setFiltroQuantidade] = useState(0);
    const [filtroPreco, setFiltroPreco] = useState(0);
    const [filtroPrecoTotal, setFiltroPrecoTotal] = useState(0);
    const [filtroNumEncomenda, setFiltroNumEncomenda] = useState('');
    const [formattedDateEnc, setFormattedDateEnc] = useState('');
    const [dataPdf, setDataPdf] = useState('');
    const [filtroDtEncomenda, setFiltroDtEncomenda] = useState({startDate: null, endDate: null});

    // ARRAYS PARQUE DE EQUIPAMENTOS

    const [marcas, setMarcas] = useState([]);
    const [nacionaisInternacionais, setNacionaisInternacionais] = useState([]);
    const [tipos, setTipos] = useState([]);
    const [modelos, setModelos] = useState([]);
    const [versoes, setVersoes] = useState([]);

    // FILTROS MAPAS

    const [max, setMax] = useState(0);
    const [min, setMin] = useState(0);
    const [valorMin, setValorMin] = useState(0);
    const [valorMax, setValorMax] = useState(0);

    useEffect(() => {
        getMarcas(lang).then(res => {
            if (res.data.success) {
                setMarcas(res.data.marcas);
            }
        });

        getNacionaisInternacionais(lang).then(res => {
            if (res.data.success) {
                setNacionaisInternacionais(res.data.nacionaisInternacionais);
            }
        });

        getTipos(lang).then(res => {
            if (res.data.success) {
                setTipos(res.data.tipos);
            }
        });

        getModelos(lang).then(res => {
            if (res.data.success) {
                setModelos(res.data.modelos);
            }
        });

        getVersoes(lang).then(res => {
            if (res.data.success) {
                setVersoes(res.data.versoes);
            }
        });
    }, []);

    // FILTROS PARQUE DE EQUIPAMENTO

    const [filtroNumEquipamento, setFiltroNumEquipamento] = useState('');
    const [filtroDescParque, setFiltroDescParque] = useState('');
    const [filtroNumSerie, setFiltroNumSerie] = useState('');
    const [filtroArtigo, setFiltroArtigo] = useState('');
    const [filtroMarca, setFiltroMarca] = useState(null);
    const [filtroNacionalInternacional, setFiltroNacionalInternacional] = useState(null);
    const [filtroTipo, setFiltroTipo] = useState(null);
    const [filtroModelo, setFiltroModelo] = useState(null);
    const [filtroVersao, setFiltroVersao] = useState(null);
    const [filtroEspecificacao, setFiltroEspecificacao] = useState('');

    // FILTROS CONTA CORRENTE

    const [filtroSociedade, setFiltroSociedade] = useState('');
    const [filtroEstab, setFiltroEstab] = useState('');
    const [filtroEndereco, setFiltroEndereco] = useState('');
    const [filtroDtFatura, setFiltroDtFatura] = useState({startDate: null, endDate: null});
    const [filtroDtVencimento, setFiltroDtVencimento] = useState({startDate: null, endDate: null});
    const [filtroRep, setFiltroRep] = useState('');
    const [filtroValor, setFiltroValor] = useState('');
    const [filtroValorPendente, setFiltroValorPendente] = useState('');
    const [filtroNumDoc, setFiltroNumDoc] = useState('');
    const [filtroDivisa, setFiltroDivisa] = useState('');

    // ARRAYS CONTA CORRENTE

    const [representantes, setRepresentantes] = useState([]);
    const [estabelecimentos, setEstabelecimentos] = useState([]);
    const [divisas, setDivisas] = useState([]);

    // FILTROS HISTORICO INTERAÇÕES

    const [filtroCodigo, setFiltroCodigo] = useState('');
    const [filtroEstabHistorico, setFiltroEstabHistorico] = useState('');
    const [filtroCategoria, setFiltroCategoria] = useState('');
    const [filtroDtInicio, setFiltroDtInicio] = useState({startDate: null, endDate: null});
    const [filtroDtFim, setFiltroDtFim] = useState({startDate: null, endDate: null});
    const [filtroRepHistorico, setFiltroRepHistorico] = useState('');

    // ARRAYS HISTORICO INTERAÇÕES
    const [categorias, setCategorias] = useState([]);

    // FILTROS HISTORICO DE OPORTUNIDADES
    const [filtroNomeHistorico, setFiltroNomeHistorico] = useState('');
    const [filtroEtapa, setFiltroEtapa] = useState('');
    const [filtroRepHisOp, setFiltroRepHisOp] = useState('');

    const [filtroEmpresa, setFiltroEmpresa] = useState('');
    const [filtroDt, setFiltroDt] = useState({startDate: null, endDate: null});
    const [filtroValorHistorico, setFiltroValorHistorico] = useState(0);

    // ARRAY HISTORICO DE OPORTUNIDADES
    const [etapasHistoricoOp, setEtapasHistoricoOp] = useState([]);
    const [representantesHistoricoOp, setRepresentantesHistoricoOp] = useState([]);

    // FILTROS HISTORICO PROPOSTA

    const [filtroId, setFiltroId] = useState('');
    const [filtroTipoProposta, setFiltroTipoProposta] = useState('');
    const [filtroDtProposta, setFiltroDtProposta] = useState({
        startDate: null,
        endDate: null,
    });
    const [filtroCliente, setFiltroCliente] = useState('');
    const [filtroEstado, setFiltroEstado] = useState('');
    const [filtroLinhas, setFiltroLinhas] = useState('');
    const [formattedDate, setFormattedDate] = useState('');

    // ARRAYS HISTORICO PROPOSTA

    const [ids, setIds] = useState([]);
    const [tiposProposta, setTiposProposta] = useState([]);
    const [estados, setEstados] = useState([]);

    //-----------------------------

    const [isOpen, setIsOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    const [dropDownValue, setDropDownValue] = useState('');

    useEffect(() => {
        getPaises(lang).then(res => {
            setPaises(res.data.paises);
        });

        getPaisAtual(lang).then(res => {
            setFiltroPais(res.data.pais);
        });

        getRepresentantes(lang).then(res => {
            setRepresentantes(res.data.representantes);
        });
    }, []);

    const handleResize = () => {
        setIsMobile(window.innerWidth < 800);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);
    useEffect(() => {
        if (prospectSelecionado != null && showForm) {
            setPath(t('editarConta') + ' ' + prospectSelecionado.codigoCliente + '-' + prospectSelecionado.nomeCliente);
        } else if (showForm && prospectSelecionado == null) {
            setPath(t('criarConta'));
        } else {
            setPath('');
        }
    }, [prospectSelecionado, showForm]);

    useEffect(() => {
        debugger;
        if (history.location.state?.lead) {
            setOpenTab(1);
            setShowForm(true);
            setEditarProspect(true);
        }
    }, [history]);

    useEffect(() => {
        if (!showForm) {
            setOpenTab(10);
        }
    }, [showForm]);

    const tabText = tab => {
        switch (tab) {
            case 1:
                return {
                    text: t('detalhes'),
                    icon: <PublicOutlinedIcon className="mr-2" />,
                };
            case 2:
                return {
                    text: t('endereco'),
                    icon: <FmdGoodOutlinedIcon className="mr-2" />,
                };
            case 3:
                return {
                    text: t('contactos'),
                    icon: <CallOutlinedIcon className="mr-2" />,
                };
            case 4:
                return {
                    text: t('produtosVendidos'),
                    icon: <InventoryOutlinedIcon className="mr-2" />,
                };
            case 5:
                return {
                    text: t('parqueEquipamentos'),
                    icon: <WorkspacesOutlinedIcon className="mr-2" />,
                };
            case 6:
                return {
                    text: t('contaCorrente'),
                    icon: <RequestQuoteOutlinedIcon className="mr-2" />,
                };
            case 7:
                return {
                    text: t('historicoVisitas'),
                    icon: <HistoryOutlinedIcon className="mr-2" />,
                };
            case 8:
                return {
                    text: t('historicoOportunidades'),
                    icon: <HistoryOutlinedIcon className="mr-2" />,
                };
            case 9:
                return {
                    text: t('historicoPropostas'),
                    icon: <HistoryOutlinedIcon className="mr-2" />,
                };
            default:
                return {
                    text: '',
                    icon: null,
                };
        }
    };
    const {text, icon} = tabText(openTab);
    return (
        <>
            <div className="border-b mb-5 border-gray-200 dark:border-gray-600">
                <div className="flex flex-wrap items-center justify-between -mb-px text-sm font-medium text-center dark:text-gray-400 text-gray-500">
                    <div className="flex space-x-2" role="tablist" id="myTab" data-tabs-toggle="#myTabContent">
                        {!showForm && (
                            <div>
                                <button
                                    aria-controls="agenda"
                                    id="agenda-tab"
                                    type="button"
                                    data-toggle="tab"
                                    href="#link1"
                                    role="tablist"
                                    aria-current="page"
                                    className={
                                        'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                        (openTab === 10
                                            ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                            : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                    }
                                    onClick={e => {
                                        e.preventDefault();
                                        setOpenTab(10);
                                    }}>
                                    <ListAltRoundedIcon className="mr-2" />
                                    {t('listagem')}
                                </button>
                                <button
                                    aria-controls="calendario"
                                    id="calendario-tab"
                                    data-toggle="tab"
                                    href="#link2"
                                    role="tablist"
                                    type="button"
                                    // className="inline-flex items-center justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group"
                                    className={
                                        'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                        (openTab === 11
                                            ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                            : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                    }
                                    onClick={e => {
                                        e.preventDefault();
                                        setOpenTab(11);
                                    }}>
                                    <PersonPinCircleOutlinedIcon className="mr-2" />
                                    {t('mapa')}
                                </button>
                            </div>
                        )}
                    </div>
                    <DrawerFilter
                        paises={paises}
                        download={download}
                        setDownload={setDownload}
                        valorMax={valorMax}
                        valorMin={valorMin}
                        max={max}
                        min={min}
                        setValorMax={setValorMax}
                        setValorMin={setValorMin}
                        setShowForm={estado => {
                            setShowForm(estado);
                            setProspectSelecionado(null);
                        }}
                        showForm={showForm}
                        setProspectSelecionado={setProspectSelecionado}
                        prospectSelecionado={prospectSelecionado}
                        setEditarProspect={setEditarProspect}
                        editarProspect={editarProspect}
                        setOnChangeForm={setOnChangeForm}
                        onChangeForm={onChangeForm}
                        setGuardar={setGuardar}
                        setOpenTab={setOpenTab}
                        openTab={openTab}
                        setNovaReuniaoVisita={setNovaReuniaoVisita}
                        setNovoNegocio={setNovoNegocio}
                        //
                        className="flex justify-end"
                        filtroNome={filtroNome}
                        setFiltroNome={setFiltroNome}
                        filtroNif={filtroNif}
                        setFiltroNif={setFiltroNif}
                        filtroCidade={filtroCidade}
                        setFiltroCidade={setFiltroCidade}
                        filtroPais={filtroPais}
                        setFiltroPais={setFiltroPais}
                        filtroRepresentante={filtroRepresentante}
                        setFiltroRepresentante={setFiltroRepresentante}
                        //produtos vendidos
                        filtroReferencia={filtroReferencia}
                        setFiltroReferencia={setFiltroReferencia}
                        filtroDesc={filtroDesc}
                        setFiltroDesc={setFiltroDesc}
                        filtroQuantidade={filtroQuantidade}
                        setFiltroQuantidade={setFiltroQuantidade}
                        filtroPreco={filtroPreco}
                        setFiltroPreco={setFiltroPreco}
                        filtroPrecoTotal={filtroPrecoTotal}
                        setFiltroPrecoTotal={setFiltroPrecoTotal}
                        filtroNumEncomenda={filtroNumEncomenda}
                        setFiltroNumEncomenda={setFiltroNumEncomenda}
                        filtroDtEncomenda={filtroDtEncomenda}
                        setFiltroDtEncomenda={setFiltroDtEncomenda}
                        formattedDateEnc={formattedDateEnc}
                        setFormattedDateEnc={setFormattedDateEnc}
                        dataPdf={dataPdf}
                        setDataPdf={setDataPdf}
                        //PARQUE DE EQUIPAMENTOS
                        filtroNumEquipamento={filtroNumEquipamento}
                        setFiltroNumEquipamento={setFiltroNumEquipamento}
                        filtroNumSerie={filtroNumSerie}
                        setFiltroNumSerie={setFiltroNumSerie}
                        filtroArtigo={filtroArtigo}
                        setFiltroArtigo={setFiltroArtigo}
                        filtroMarca={filtroMarca}
                        setFiltroMarca={setFiltroMarca}
                        filtroNacionalInternacional={filtroNacionalInternacional}
                        setFiltroNacionalInternacional={setFiltroNacionalInternacional}
                        filtroTipo={filtroTipo}
                        setFiltroTipo={setFiltroTipo}
                        filtroModelo={filtroModelo}
                        setFiltroModelo={setFiltroModelo}
                        filtroVersao={filtroVersao}
                        setFiltroVersao={setFiltroVersao}
                        filtroEspecificacao={filtroEspecificacao}
                        setFiltroEspecificacao={setFiltroEspecificacao}
                        marcas={marcas}
                        setMarcas={setMarcas}
                        nacionaisInternacionais={nacionaisInternacionais}
                        setNacionaisInternacionais={setNacionaisInternacionais}
                        tipos={tipos}
                        setTipos={setTipos}
                        modelos={modelos}
                        setModelos={setModelos}
                        versoes={versoes}
                        setVersoes={setVersoes}
                        filtroDescParque={filtroDescParque}
                        setFiltroDescParque={setFiltroDescParque}
                        // conta corrente
                        filtroSociedade={filtroSociedade}
                        setFiltroSociedade={setFiltroSociedade}
                        filtroEstab={filtroEstab}
                        setFiltroEstab={setFiltroEstab}
                        filtroEndereco={filtroEndereco}
                        setFiltroEndereco={setFiltroEndereco}
                        filtroDtFatura={filtroDtFatura}
                        setFiltroDtFatura={setFiltroDtFatura}
                        filtroDtVencimento={filtroDtVencimento}
                        setFiltroDtVencimento={setFiltroDtVencimento}
                        filtroRep={filtroRep}
                        setFiltroRep={setFiltroRep}
                        filtroValor={filtroValor}
                        setFiltroValor={setFiltroValor}
                        filtroValorPendente={filtroValorPendente}
                        setFiltroValorPendente={setFiltroValorPendente}
                        filtroNumDoc={filtroNumDoc}
                        setFiltroNumDoc={setFiltroNumDoc}
                        filtroDivisa={filtroDivisa}
                        setFiltroDivisa={setFiltroDivisa}
                        representantes={representantes}
                        setRepresentantes={setRepresentantes}
                        estabelecimentos={estabelecimentos}
                        setEstabelecimentos={setEstabelecimentos}
                        divisas={divisas}
                        setDivisas={setDivisas}
                        //
                        //historico visitas
                        filtroCodigo={filtroCodigo}
                        setFiltroCodigo={setFiltroCodigo}
                        filtroEstabHistorico={filtroEstabHistorico}
                        setFiltroEstabHistorico={setFiltroEstabHistorico}
                        filtroCategoria={filtroCategoria}
                        setFiltroCategoria={setFiltroCategoria}
                        filtroDtInicio={filtroDtInicio}
                        setFiltroDtInicio={setFiltroDtInicio}
                        filtroDtFim={filtroDtFim}
                        setFiltroDtFim={setFiltroDtFim}
                        filtroRepHistorico={filtroRepHistorico}
                        setFiltroRepHistorico={setFiltroRepHistorico}
                        categorias={categorias}
                        setCategorias={setCategorias}
                        //historico de oportunidades
                        filtroNomeHistorico={filtroNomeHistorico}
                        setFiltroNomeHistorico={setFiltroNomeHistorico}
                        filtroEtapa={filtroEtapa}
                        setFiltroEtapa={setFiltroEtapa}
                        filtroRepHisOp={filtroRepHisOp}
                        setFiltroRepHisOp={setFiltroRepHisOp}
                        filtroEmpresa={filtroEmpresa}
                        setFiltroEmpresa={setFiltroEmpresa}
                        filtroDt={filtroDt}
                        setFiltroDt={setFiltroDt}
                        filtroValorHistorico={filtroValorHistorico}
                        setFiltroValorHistorico={setFiltroValorHistorico}
                        etapasHistoricoOp={etapasHistoricoOp}
                        setEtapasHistoricoOp={setEtapasHistoricoOp}
                        setRepresentantesHistoricoOp={setRepresentantesHistoricoOp}
                        representantesHistoricoOp={representantesHistoricoOp}
                        //historico propostas
                        filtroId={filtroId}
                        setFiltroId={setFiltroId}
                        filtroTipoProposta={filtroTipoProposta}
                        setFiltroTipoProposta={setFiltroTipoProposta}
                        filtroDtProposta={filtroDtProposta}
                        setFiltroDtProposta={setFiltroDtProposta}
                        filtroCliente={filtroCliente}
                        setFiltroCliente={setFiltroCliente}
                        filtroEstado={filtroEstado}
                        setFiltroEstado={setFiltroEstado}
                        filtroLinhas={filtroLinhas}
                        setFiltroLinhas={setFiltroLinhas}
                        formattedDate={formattedDate}
                        setFormattedDate={setFormattedDate}
                        ids={ids}
                        setIds={setIds}
                        tiposProposta={tiposProposta}
                        setTiposProposta={setTiposProposta}
                        estados={estados}
                        setEstados={setEstados}
                    />
                </div>

                {isMobile && showForm ? (
                    <div className="relative mb-4 mt-2">
                        <button
                            onClick={() => setIsOpen(!isOpen)}
                            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-[8px] text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                            type="button">
                            {icon} {text}{' '}
                            <svg className="w-2.5 h-2.5 ms-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4" />
                            </svg>
                        </button>

                        {isOpen && (
                            <div className="absolute z-10 w-60 mt-2 bg-white divide-y divide-gray-100 rounded-[8px] shadow  dark:bg-gray-700">
                                <ul className="py-2 text-sm text-gray-700 dark:text-gray-200 w-60">
                                    <li>
                                        <a
                                            href="#"
                                            onClick={e => {
                                                setDropDownValue(t('detalhes'));
                                                e.preventDefault();
                                                setOpenTab(1);
                                                setIsOpen(false);
                                            }}
                                            className={`block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white ${openTab === 1 ? 'bg-blue-500 text-white' : ''}`}>
                                            <PublicOutlinedIcon className="mr-2" /> {t('detalhes')}
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="#"
                                            onClick={e => {
                                                e.preventDefault();
                                                setOpenTab(2);
                                                setIsOpen(false);
                                            }}
                                            className={`block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white ${openTab === 2 ? 'bg-blue-500 text-white' : ''}`}>
                                            <FmdGoodOutlinedIcon className="mr-2" />
                                            {t('endereco')}
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            onClick={e => {
                                                e.preventDefault();
                                                setOpenTab(3);
                                                setIsOpen(false);
                                            }}
                                            href="#"
                                            className={`block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white ${openTab === 3 ? 'bg-blue-500 text-white' : ''}`}>
                                            <CallOutlinedIcon className="mr-2" />
                                            {t('contactos')}
                                        </a>
                                    </li>
                                    {!!prospectSelecionado && (
                                        <>
                                            <li>
                                                <a
                                                    href="#"
                                                    onClick={e => {
                                                        e.preventDefault();
                                                        setOpenTab(4);
                                                        setIsOpen(false);
                                                    }}
                                                    className={`block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white ${openTab === 4 ? 'bg-blue-500 text-white' : ''}`}>
                                                    <InventoryOutlinedIcon className="mr-2" />
                                                    {t('produtosVendidos')}
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    href="#"
                                                    onClick={e => {
                                                        e.preventDefault();
                                                        setOpenTab(5);
                                                        setIsOpen(false);
                                                    }}
                                                    className={`block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white ${openTab === 5 ? 'bg-blue-500 text-white' : ''}`}>
                                                    <WorkspacesOutlinedIcon className="mr-2" />
                                                    {t('parqueEquipamentos')}
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    href="#"
                                                    onClick={e => {
                                                        e.preventDefault();
                                                        setOpenTab(6);
                                                        setIsOpen(false);
                                                    }}
                                                    className={`block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white ${openTab === 6 ? 'bg-blue-500 text-white' : ''}`}>
                                                    <RequestQuoteOutlinedIcon className="mr-2" />
                                                    {t('contaCorrente')}
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    href="#"
                                                    onClick={e => {
                                                        e.preventDefault();
                                                        setOpenTab(7);
                                                        setIsOpen(false);
                                                    }}
                                                    className={`block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white ${openTab === 7 ? 'bg-blue-500 text-white' : ''}`}>
                                                    <HistoryOutlinedIcon className="mr-2" />
                                                    {t('historicoVisitas')}
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    href="#"
                                                    onClick={e => {
                                                        e.preventDefault();
                                                        setOpenTab(8);
                                                        setIsOpen(false);
                                                    }}
                                                    className={`block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white ${openTab === 8 ? 'bg-blue-500 text-white' : ''}`}>
                                                    <HistoryOutlinedIcon className="mr-2" />
                                                    {t('historicoOportunidades')}
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    href="#"
                                                    onClick={e => {
                                                        e.preventDefault();
                                                        setOpenTab(9);
                                                        setIsOpen(false);
                                                    }}
                                                    className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                    <HistoryOutlinedIcon className="mr-2" />
                                                    {t('historicoPropostas')}
                                                </a>
                                            </li>
                                        </>
                                    )}
                                </ul>
                            </div>
                        )}
                    </div>
                ) : (
                    <div
                        className="flex flex-wrap items-center justify-between -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400"
                        role="tablist"
                        id="myTab"
                        data-tabs-toggle="#myTabContent">
                        <div className="flex space-x-2">
                            <div className={showForm ? 'block' : 'hidden'}>
                                <button
                                    aria-controls="agenda"
                                    id="agenda-tab"
                                    type="button"
                                    data-toggle="tab"
                                    href="#link1"
                                    role="tablist"
                                    aria-current="page"
                                    className={
                                        'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                        (openTab === 1
                                            ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                            : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                    }
                                    onClick={e => {
                                        e.preventDefault();
                                        setOpenTab(1);
                                    }}>
                                    <PublicOutlinedIcon className="mr-2" />
                                    {t('detalhes')}
                                </button>
                                <button
                                    aria-controls="calendario"
                                    id="calendario-tab"
                                    data-toggle="tab"
                                    href="#link2"
                                    role="tablist"
                                    type="button"
                                    className={
                                        'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                        (openTab === 2
                                            ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                            : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                    }
                                    onClick={e => {
                                        e.preventDefault();
                                        setOpenTab(2);
                                    }}>
                                    <FmdGoodOutlinedIcon className="mr-2" />
                                    {t('endereco')}
                                </button>
                                <button
                                    aria-controls="calendario"
                                    id="calendario-tab"
                                    data-toggle="tab"
                                    href="#link3"
                                    role="tablist"
                                    type="button"
                                    className={
                                        'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                        (openTab === 3
                                            ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                            : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                    }
                                    onClick={e => {
                                        e.preventDefault();
                                        setOpenTab(3);
                                    }}>
                                    <CallOutlinedIcon className="mr-2" />
                                    {t('contactos')}
                                </button>

                                {!!prospectSelecionado && (
                                    <>
                                        <button
                                            aria-controls="calendario"
                                            id="calendario-tab"
                                            data-toggle="tab"
                                            href="#link4"
                                            role="tablist"
                                            type="button"
                                            className={
                                                'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                                (openTab === 4
                                                    ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                                    : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                            }
                                            onClick={e => {
                                                e.preventDefault();
                                                setOpenTab(4);
                                            }}>
                                            <InventoryOutlinedIcon className="mr-2" />
                                            {t('produtosVendidos')}
                                        </button>
                                    </>
                                )}
                                {
                                    <button
                                        aria-controls="calendario"
                                        id="calendario-tab"
                                        data-toggle="tab"
                                        href="#link4"
                                        role="tablist"
                                        type="button"
                                        className={
                                            'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                            (openTab === 5
                                                ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                                : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                        }
                                        onClick={e => {
                                            e.preventDefault();
                                            setOpenTab(5);
                                        }}>
                                        <WorkspacesOutlinedIcon className="mr-2" />
                                        {t('parqueEquipamentos')}
                                    </button>
                                }
                                {!!prospectSelecionado && (
                                    <>
                                        <button
                                            aria-controls="calendario"
                                            id="calendario-tab"
                                            data-toggle="tab"
                                            href="#link4"
                                            role="tablist"
                                            type="button"
                                            className={
                                                'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                                (openTab === 6
                                                    ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                                    : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                            }
                                            onClick={e => {
                                                e.preventDefault();
                                                setOpenTab(6);
                                            }}>
                                            <RequestQuoteOutlinedIcon className="mr-2" />
                                            {t('contaCorrente')}
                                        </button>
                                        <button
                                            aria-controls="calendario"
                                            id="calendario-tab"
                                            data-toggle="tab"
                                            href="#link4"
                                            role="tablist"
                                            type="button"
                                            className={
                                                'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                                (openTab === 7
                                                    ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                                    : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                            }
                                            onClick={e => {
                                                e.preventDefault();
                                                setOpenTab(7);
                                            }}>
                                            <HistoryOutlinedIcon className="mr-2" />
                                            {t('historicoVisitas')}
                                        </button>
                                        <button
                                            aria-controls="calendario"
                                            id="calendario-tab"
                                            data-toggle="tab"
                                            href="#link4"
                                            role="tablist"
                                            type="button"
                                            className={
                                                'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                                (openTab === 8
                                                    ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                                    : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                            }
                                            onClick={e => {
                                                e.preventDefault();
                                                setOpenTab(8);
                                            }}>
                                            <HistoryOutlinedIcon className="mr-2" />
                                            {t('historicoOportunidades')}
                                        </button>
                                        <button
                                            aria-controls="calendario"
                                            id="calendario-tab"
                                            data-toggle="tab"
                                            href="#link4"
                                            role="tablist"
                                            type="button"
                                            className={
                                                'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                                (openTab === 9
                                                    ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                                    : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                            }
                                            onClick={e => {
                                                e.preventDefault();
                                                setOpenTab(9);
                                            }}>
                                            <HistoryOutlinedIcon className="mr-2" />
                                            {t('historicoPropostas')}
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {!showForm && openTab == 10 && (
                <Tabela
                    representantes={representantes}
                    paises={paises}
                    filtroNome={filtroNome}
                    setFiltroNome={setFiltroNome}
                    filtroNif={filtroNif}
                    setFiltroNif={setFiltroNif}
                    filtroCidade={filtroCidade}
                    setFiltroCidade={setFiltroCidade}
                    filtroPais={filtroPais}
                    setFiltroPais={setFiltroPais}
                    filtroRepresentante={filtroRepresentante}
                    setFiltroRepresentante={setFiltroRepresentante}
                    onRowClick={handleRowClick}
                    setEditarProspect={setEditarProspect}
                    download={download}
                    setDownload={setDownload}
                />
            )}
            {!showForm && openTab == 11 && (
                <Mapa
                    valorMax={valorMax}
                    valorMin={valorMin}
                    setValorMax={setValorMax}
                    setValorMin={setValorMin}
                    max={max}
                    min={min}
                    setMax={setMax}
                    setMin={setMin}
                    setShowForm={setShowForm}
                    setOpenTab={setOpenTab}
                    setEditarProspect={setEditarProspect}
                    onRowClick={handlePopUpClick}
                />
            )}

            {showForm && (
                <ProspectsForm
                    //produtos vendidos
                    setOpenTab={setOpenTab}
                    openTab={openTab}
                    filtroReferencia={filtroReferencia}
                    setFiltroReferencia={setFiltroReferencia}
                    filtroDesc={filtroDesc}
                    setFiltroDesc={setFiltroDesc}
                    filtroQuantidade={filtroQuantidade}
                    setFiltroQuantidade={setFiltroQuantidade}
                    filtroPreco={filtroPreco}
                    setFiltroPreco={setFiltroPreco}
                    filtroNumEncomenda={filtroNumEncomenda}
                    setFiltroNumEncomenda={setFiltroNumEncomenda}
                    filtroDtEncomenda={filtroDtEncomenda}
                    setFiltroDtEncomenda={setFiltroDtEncomenda}
                    formattedDateEnc={formattedDateEnc}
                    setFormattedDateEnc={setFormattedDateEnc}
                    dataPdf={dataPdf}
                    setDataPdf={setDataPdf}
                    // parque de equipamentos
                    filtroNumEquipamento={filtroNumEquipamento}
                    setFiltroNumEquipamento={setFiltroNumEquipamento}
                    filtroNumSerie={filtroNumSerie}
                    setFiltroNumSerie={setFiltroNumSerie}
                    filtroArtigo={filtroArtigo}
                    setFiltroArtigo={setFiltroArtigo}
                    filtroMarca={filtroMarca}
                    setFiltroMarca={setFiltroMarca}
                    filtroNacionalInternacional={filtroNacionalInternacional}
                    setFiltroNacionalInternacional={setFiltroNacionalInternacional}
                    filtroTipo={filtroTipo}
                    setFiltroTipo={setFiltroTipo}
                    filtroModelo={filtroModelo}
                    setFiltroModelo={setFiltroModelo}
                    filtroVersao={filtroVersao}
                    setFiltroVersao={setFiltroVersao}
                    filtroEspecificacao={filtroEspecificacao}
                    setFiltroEspecificacao={setFiltroEspecificacao}
                    marcas={marcas}
                    setMarcas={setMarcas}
                    nacionaisInternacionais={nacionaisInternacionais}
                    setNacionaisInternacionais={setNacionaisInternacionais}
                    tipos={tipos}
                    setTipos={setTipos}
                    modelos={modelos}
                    setModelos={setModelos}
                    versoes={versoes}
                    setVersoes={setVersoes}
                    filtroDescParque={filtroDescParque}
                    setFiltroDescParque={setFiltroDescParque}
                    filtroPrecoTotal={filtroPrecoTotal}
                    setFiltroPrecoTotal={setFiltroPrecoTotal}
                    // conta corrente
                    filtroSociedade={filtroSociedade}
                    setFiltroSociedade={setFiltroSociedade}
                    filtroEstab={filtroEstab}
                    setFiltroEstab={setFiltroEstab}
                    filtroEndereco={filtroEndereco}
                    setFiltroEndereco={setFiltroEndereco}
                    filtroDtFatura={filtroDtFatura}
                    setFiltroDtFatura={setFiltroDtFatura}
                    filtroDtVencimento={filtroDtVencimento}
                    setFiltroDtVencimento={setFiltroDtVencimento}
                    filtroRep={filtroRep}
                    setFiltroRep={setFiltroRep}
                    filtroValor={filtroValor}
                    setFiltroValor={setFiltroValor}
                    filtroValorPendente={filtroValorPendente}
                    setFiltroValorPendente={setFiltroValorPendente}
                    filtroNumDoc={filtroNumDoc}
                    setFiltroNumDoc={setFiltroNumDoc}
                    filtroDivisa={filtroDivisa}
                    setFiltroDivisa={setFiltroDivisa}
                    representantes={representantes}
                    setRepresentantes={setRepresentantes}
                    estabelecimentos={estabelecimentos}
                    setEstabelecimentos={setEstabelecimentos}
                    divisas={divisas}
                    setDivisas={setDivisas}
                    //historico visitas
                    filtroCodigo={filtroCodigo}
                    setFiltroCodigo={setFiltroCodigo}
                    filtroEstabHistorico={filtroEstabHistorico}
                    setFiltroEstabHistorico={setFiltroEstabHistorico}
                    filtroCategoria={filtroCategoria}
                    setFiltroCategoria={setFiltroCategoria}
                    filtroDtInicio={filtroDtInicio}
                    setFiltroDtInicio={setFiltroDtInicio}
                    filtroDtFim={filtroDtFim}
                    setFiltroDtFim={setFiltroDtFim}
                    filtroRepHistorico={filtroRepHistorico}
                    setFiltroRepHistorico={setFiltroRepHistorico}
                    categorias={categorias}
                    setCategorias={setCategorias}
                    //historico de oportunidades
                    filtroNomeHistorico={filtroNomeHistorico}
                    setFiltroNomeHistorico={setFiltroNomeHistorico}
                    filtroEtapa={filtroEtapa}
                    setFiltroEtapa={setFiltroEtapa}
                    filtroRepHisOp={filtroRepHisOp}
                    setFiltroRepHisOp={setFiltroRepHisOp}
                    filtroEmpresa={filtroEmpresa}
                    setFiltroEmpresa={setFiltroEmpresa}
                    filtroDt={filtroDt}
                    setFiltroDt={setFiltroDt}
                    filtroValorHistorico={filtroValorHistorico}
                    setFiltroValorHistorico={setFiltroValorHistorico}
                    etapasHistoricoOp={etapasHistoricoOp}
                    setEtapasHistoricoOp={setEtapasHistoricoOp}
                    setRepresentantesHistoricoOp={setRepresentantesHistoricoOp}
                    representantesHistoricoOp={representantesHistoricoOp}
                    //historico propostas
                    filtroId={filtroId}
                    setFiltroId={setFiltroId}
                    filtroTipoProposta={filtroTipoProposta}
                    setFiltroTipoProposta={setFiltroTipoProposta}
                    filtroDtProposta={filtroDtProposta}
                    setFiltroDtProposta={setFiltroDtProposta}
                    filtroCliente={filtroCliente}
                    setFiltroCliente={setFiltroCliente}
                    filtroEstado={filtroEstado}
                    setFiltroEstado={setFiltroEstado}
                    filtroLinhas={filtroLinhas}
                    setFiltroLinhas={setFiltroLinhas}
                    formattedDate={formattedDate}
                    setFormattedDate={setFormattedDate}
                    ids={ids}
                    setIds={setIds}
                    tiposProposta={tiposProposta}
                    setTiposProposta={setTiposProposta}
                    estados={estados}
                    setEstados={setEstados}
                    //
                    prospect={prospectSelecionado}
                    setShowForm={setShowForm}
                    setEditarProspect={setEditarProspect}
                    editarProspect={editarProspect}
                    setGuardar={setGuardar}
                    guardar={guardar}
                    setOnChangeForm={setOnChangeForm}
                    setNovaReuniaoVisita={setNovaReuniaoVisita}
                    novaReuniaoVisita={novaReuniaoVisita}
                    setNovoNegocio={setNovoNegocio}
                    novoNegocio={novoNegocio}
                />
            )}

            <ToastContainer />
        </>
    );
}

export default Prospects;
